<mat-toolbar color="accent">Create Marketing Campaign</mat-toolbar>

<mat-dialog-content class="!p-0 !text-black">
  <mat-stepper #stepper [linear]="true">
    <mat-step>
      <ng-template matStepLabel>Select Template</ng-template>
      <div class="flex flex-col gap-4">
        <pr-campaign-template-selector
          (templateSelected)="selectTemplate($event)"
        />
        <div class="flex flex-row justify-end gap-2 pt-4">
          <button mat-stroked-button mat-dialog-close>Cancel</button>
          <button
            mat-flat-button
            color="primary"
            matStepperNext
            [disabled]="!templateValue()"
          >
            Next
          </button>
        </div>
      </div>
    </mat-step>
    <mat-step>
      <ng-template matStepLabel>Campaign Settings</ng-template>

      <div class="flex flex-col gap-4">
        <pr-campaign-settings-form
          #settingsForm
          [formValue]="settingsValue()"
          (formValueChange)="settingsValue.set($event)"
        />

        <div class="flex flex-row justify-end gap-2 pt-4">
          <button mat-stroked-button mat-dialog-close>Cancel</button>
          <button
            mat-flat-button
            color="primary"
            [disabled]="!settingsForm.form.valid || !templateValue()"
            (click)="submit()"
          >
            Create Campaign
          </button>
        </div>
      </div>
    </mat-step>
  </mat-stepper>
</mat-dialog-content>
